<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType"
                  :params="{operationId: operationId, currentSection:3, operationBilanId:operationBilanId}"
                  :sub-title-ope="this.operationName"
                  :title="$t('operation.bilan.Honoraires')"
                  route-back="OperationShow"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="prixHT | formatEuro"
        class="ml-auto col-md-2"
        title="operation.totalht"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTVA | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totaltva"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTTC | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totalttc"/>

    </div>

    <div class="row justify-content-between mt-3 mb-4">
      <div class="col-md-12">
        <div class="white-card mr-0 p-3">
          <div>
            <div class="section-title" >
              {{ $t('operationHonoraire.general') }}
            </div>
            <div class="d-flex justify-content-between intitule" v-if="operationHonoraires && operationHonoraires.length > 0 && operationHonoraires.find(operationHonoraire => (operationHonoraire.data.operation !== null && operationHonoraire.data.operation.id === operationId) || ( operationHonoraire.selectedLots.length !== 0) )">
              <p class="info-text mar-r-100" >Nom</p>
              <p class="info-text mar-l-100">Devis validé / Factures direct</p>
              <div class="row">
                <p class="info-text mar-l-40 mar-r-100">
                  {{ $t(`operationHonoraire.header.total${operation && operation.isHT ? "HT" : "TTC"}`) }}
                </p>
                <p class="info-text">
                  {{ $t(`operationHonoraire.header.paiementAVenir${operation && operation.isHT ? ".HT" : ""}`) }}
                </p>
              </div>
              <p class="info-text"></p>
            </div>
            <template v-for="operationHonoraire in operationHonoraires">
              <div
                v-if="((operationHonoraire.data.operation !== null && operationHonoraire.data.operation.id === operationId) || ( operationHonoraire.selectedLots.length !== 0)) "
                class="mb-3">
                <operation-honoraire-component
                  :contact-names="contactNames"
                  :index="operationHonoraires.indexOf(operationHonoraire)"
                  :is-general="true"
                  :isHT = "!!(operation && operation.isHT)"
                  :operation-honoraire="operationHonoraire.data"
                  :operation-lots="operationLots"
                  :selected-lots="operationHonoraire.selectedLots"
                  @didChangeValue="emitChangeValue"
                  @editedOperationHonoraire="editedOperationHonoraire"
                  @removedOperationHonoraire="removedOperationHonoraire"/>

              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <span class="bold-text addLink"
                      @click="addOperationHonoraireGeneral(operation)"> {{ $t('operationHonoraire.Add') }}</span>
              </div>
            </div>
          </div>
          <div v-for="(operationLot, index) in operationLots" :key="index" class="section-type-honoraire">
            <div class="level-two-title main-red-color bold-text">
              {{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber + ' - ' + operationLot.name }}
            </div>

            <div class="d-flex justify-content-between intitule" v-if="operationHonoraires && operationHonoraires.length > 0 && operationHonoraires.find(operationHonoraire => operationHonoraire.data.operationLot != null && (operationHonoraire.data.operationLot.id === operationLot.id && operationHonoraire.selectedLots.length === 0 ) )">
              <p class="info-text mar-r-160" >Nom</p>
              <p class="info-text ">Devis validé / Factures direct</p>
              <div class="row">
                <p class="info-text mar-l-40 mar-r-100">
                  {{ $t(`operationHonoraire.header.total${operation && operation.isHT ? "HT" : "TTC"}`) }}
                </p>
                <p class="info-text">
                  {{ $t(`operationHonoraire.header.paiementAVenir${operation && operation.isHT ? ".HT" : ""}`) }}
                </p>
              </div>
              <p class="info-text"></p>
            </div>

            <template v-for="operationHonoraire in operationHonoraires">

              <operation-honoraire-component
                v-if="operationHonoraire.data.operationLot != null && (operationHonoraire.data.operationLot.id === operationLot.id && operationHonoraire.selectedLots.length === 0 )"
                :contact-names="contactNames"
                :index="operationHonoraires.indexOf(operationHonoraire)"
                :isHT = "!!(operation && operation.isHT)"
                :operation-honoraire="operationHonoraire.data"
                @didChangeValue="emitChangeValue"
                @editedOperationHonoraire="editedOperationHonoraire"
                @removedOperationHonoraire="removedOperationHonoraire"/>
            </template>

            <div class="row mt-2 mb-4">
              <div class="col-md-12">
                <span class="bold-text addLink"
                      @click="addOperationHonoraire(operationLot)"> {{ $t('operationHonoraire.Add') }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <add-operation-honoraire-modal
        v-if="isLoading === false"
        ref="addOperationHonoraireModal"
        :all-initial-date-operation-and-lot="allInitialDateOperationAndLot"
        :contact-names="contactNames"
        :operation="selected.operation"
        :operation-lot="selected.operationLot"
        :operation-lots="operationLots"
        :isHT = "!!(operation && operation.isHT)"
        :taux-t-v-a-list="tauxTVAList"
        :types="types"
        @didAddOperationHonoraire="didAddOperationHonoraire"/>

      <edit-operation-honoraire-modal
        v-if="isLoading === false && selected.operationHonoraire && selected.operationHonoraire.data && selected.operationHonoraire.data.hasOwnProperty('id') && selected.operationHonoraire.data.id"
        ref="editOperationHonoraireModal"
        :contact-names="contactNames"
        :operation-honoraire="selected.operationHonoraire"
        :operation-lots="operationLots"
        :status-facture-list="statusFactureList"
        :taux-t-v-a-list="tauxTVAList"
        :isHT = "!!(operation && operation.isHT)"
        :types="types"
        @didEditOperationHonoraire="didEditOperationHonoraire"/>

    </div>
  </b-container>
</template>

<script>

import CardTotalComponent from "../../operation/components/CardTotalComponent.vue";
import BackArrow from "../../../components/b122/BackArrow.vue";
import OperationHonoraireComponent from "../components/OperationHonoraireComponent.vue";
import AddOperationHonoraireModal from "../components/AddOperationHonoraireModal.vue";
import EditOperationHonoraireModal from "../components/EditOperationHonoraireModal.vue";
import api from "../../../services/api";
import {v4 as uuidv4} from "uuid";

export default {
  name: "OperationBilanHonorairesEdit",

  components: {
    CardTotalComponent,
    BackArrow,
    OperationHonoraireComponent,
    AddOperationHonoraireModal,
    EditOperationHonoraireModal
  },

  data() {
    return {
      totalTTC: "-",
      totalTVA: "-",
      prixHT: "-",
      operationName: null,
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      simulationId: this.$route.params.simulationId,
      allInitialDateOperationAndLot: [],
      operation: null,
      operationLots: [],
      operationHonoraires: [],
      contactNames: [],
      types: [],
      bilanType: null,
      selected: {
        operation: null,
        operationLot: null,
        operationHonoraire: {}
      },
      operationHonorairesIdsToRemove: [],
      operationHonoraireName: "",
      tauxTVAList: [],
      statusFactureList: [],
      isLoading: false,
      isHT:false
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {


    async fetchData() {
      this.isLoading = true
      await this.getOperationBilanId()
      await this.getOperationBilanType()
      await this.fetchContactTypes()
      await this.fetchContactNames()
      await this.getOperationLots()
      await this.getOperation()
      await this.getTotalOfBilan()
      await this.getAllInitialDateOperationAndLot()
      await this.getTauxTVA()
      await this.getStatusFacture()
      await this.getOperationHonoraires()
      this.isLoading = false
    },

    async getTauxTVA() {
      await api
        .get(`/operation/getTauxTVA`)
        .then(response => {
          this.tauxTVAList = response.data
        })
    },
    async getStatusFacture() {
      await api
        .get(`/facturePayment/getStatusFacture`)
        .then(response => {
          this.statusFactureList = response.data
        })
    },

    async didEditOperationHonoraire(operationHonoraire) {
      if (!operationHonoraire.data.date) {
        operationHonoraire.data.dateState = false
      }

      this.selected.operationHonoraire = operationHonoraire
      await this.emitChangeValue(operationHonoraire.data)

      this.selected.operationHonoraire = {}
    },

    async getAllInitialDateOperationAndLot() {
      await api
        .get(`/operation/getAllInitialDateOperationAndLot/${this.operationId}`)
        .then(response => {
          this.allInitialDateOperationAndLot = response.data
        })
        .catch((error) => {

        })
    },

    formatDate(dateLong) {
      return new Date(Number(dateLong)).toLocaleDateString().split("/").reverse().join("-");
    },

    getInitialDate(source, id, type, dateType) {
      let dateLong = source[type].find(x => x.id === id)[dateType];
      if (dateLong != null) {
        return this.formatDate(dateLong);
      }
      return null;
    },


    async getOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 3,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationBilanType() {
      this.isLoading = true
      api
        .get(`/operationBilan/getOperationBilanType/${this.operationBilanId}`)
        .then(response => {
          this.bilanType = response.data.bilanType
        })
    },

    async getOperationLots() {
      if (this.operationId != null) {
        await api
          .get(`/operationLot/getAllForOperation/${this.operationId}`)
          .then(response => {
            this.operationLots = response.data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 3,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.operation = response.data
            this.operationName = response.data.name
            this.isHT = response.data.isHT
          })
      }
    },

    async getOperationHonoraires() {
      if (this.operationId != null) {
        await api
          .get(`/operationHonoraire/getAllForOperation/${this.operationId}`)
          .then(response => {
            const tempHonoraires = {}

            response.data.forEach(honoraire => {
              if (honoraire['date'] != null) {
                honoraire['date'] = this.formatDate(honoraire['date']);
              } else {
                let date = null;
                if (honoraire.operationLot.id != null) {
                  date = this.getInitialDate(this.allInitialDateOperationAndLot, honoraire.operationLot.id, "operationLots", "estimatedStartDate");
                }
                if (date == null) {
                  date = this.formatDate(this.allInitialDateOperationAndLot["operation"].estimatedHonoraireDate);
                }
                honoraire['date'] = date;
              }
              honoraire['dateState'] = null

              if (honoraire.commonId && honoraire.commonId !== '') {
                if (!tempHonoraires[honoraire.commonId]) {
                  tempHonoraires[honoraire.commonId] = {
                    data: honoraire,
                    selectedLots: []
                  }
                }
                tempHonoraires[honoraire.commonId].selectedLots.push(honoraire.operationLot.id)
              } else {
                tempHonoraires[honoraire.id] = {
                  data: honoraire,
                  selectedLots: honoraire.operation.id ? this.operationLots.map(lot => lot.id) : []
                }
              }
            })
            this.operationHonoraires = Object.values(tempHonoraires)
            this.operationHonoraires.forEach(honoraire => {
              if (honoraire.data.commonId != null) {
                honoraire.data.prixTTC = honoraire.data.prixTTC * honoraire.selectedLots.length
                honoraire.data.prixHT = honoraire.data.prixHT * honoraire.selectedLots.length
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 3,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    convertTTCtoHT(prixTTC, tauxTVA) {
      if (!prixTTC || !tauxTVA) return prixTTC;
      const taux = parseFloat(tauxTVA.replace('%', '')) / 100;
      return prixTTC / (1 + taux);
    },

    async fetchContactTypes() {
      await api
        .get(`/contact/getContactTypes`)
        .then(response => {
          response.data.forEach(type => {
            if (!this.types.includes(this.$i18n.t(type))) {
              this.types.push(this.$i18n.t(type))
            }
          })
        })
    },

    async fetchContactNames() {
      await api
        .get(`/contact/getContactNames`)
        .then(response => {
          this.contactNames = (response.data || []).filter(name => name && name.trim())
        })
    },

    async emitChangeValue(operationHonoraire) {
      let startDateValid = true;
      operationHonoraire.dateState = null;

      if (operationHonoraire.operation && operationHonoraire.operation.id) {
        let opStartDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].estimatedHonoraireDate);
        startDateValid = operationHonoraire.date >= opStartDate
      } else if (operationHonoraire.operationLot && operationHonoraire.operationLot.id) {
        let lotStartDate = this.getInitialDate(this.allInitialDateOperationAndLot, operationHonoraire.operationLot.id, "operationLots", "estimatedStartDate");

        if (!lotStartDate) {
          lotStartDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].estimatedHonoraireDate);
        }

        startDateValid = operationHonoraire.date >= lotStartDate
      }

      if (!startDateValid) {
        this.toast(`${operationHonoraire.type}:  La date n'est pas comprise entre les dates initiales prévues pour l'opération ou le lot d'opération`, 'info');
        operationHonoraire.dateState = false;
      }
      if (operationHonoraire.date) {
        let index = this.operationHonoraires.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(operationHonoraire));
        if (index > -1) {
          await this.createOrUpdateOperationHonoraires(this.operationHonoraires[index])
          await this.generateMonthlyCharges()
        }
      }
    },



    addOperationHonoraire(operationLot) {
      this.selected.operationLot = operationLot
      this.selected.operation = null
      this.$bvModal.show('add-operation-honoraire-modal')
    },

    addOperationHonoraireGeneral(operation) {
      this.selected.operation = operation
      this.selected.operationLot = null
      this.$bvModal.show('add-operation-honoraire-modal')
    },


    editedOperationHonoraire(operationHonoraire) {
      if (operationHonoraire) {
        let operationHonoraireFullData = this.operationHonoraires.find((obj) => obj.data.id === operationHonoraire.id);
        if (operationHonoraireFullData) {
          this.selected.operationHonoraire = operationHonoraireFullData;
          this.$nextTick(() => {
            this.$bvModal.show('edit-operation-honoraire-modal')
          });
        }
      }
    },


    async didAddOperationHonoraire(operationHonoraire) {
      let operationLotsIds = []
      let date = null
      let uuid = uuidv4()
      let tauxTVA = "20%"

      if (this.selected.operation != null) {
        operationHonoraire.selectedLots.sort((a, b) => a - b)
        operationHonoraire.selectedLots.forEach(lot => {
          operationLotsIds.push(lot)
        });
      }
      delete operationHonoraire.selectedLots

      if (operationHonoraire.date) {
        date = operationHonoraire.date
      }

      if (operationHonoraire.tauxTVA) {
        tauxTVA = operationHonoraire.tauxTVA
      }


      this.selected.operation = null
      this.selected.operationLot = null
      const operationHonoraireToAdd = {
        ...operationHonoraire,
        date,
        tauxTVA,
        uuid
      }

      this.operationHonoraires.push({
        data: {...operationHonoraireToAdd},
        selectedLots: operationLotsIds
      });
      await this.emitChangeValue(this.operationHonoraires[this.operationHonoraires.length - 1].data)
    },


    async removedOperationHonoraire(operationHonoraire) {
      let index = this.operationHonoraires.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(operationHonoraire));
      if (operationHonoraire.id) {
        await this.deleteOperationHonoraires(operationHonoraire)
        await this.generateMonthlyCharges()
      }
      if (index > -1) {
        this.operationHonoraires.splice(index, 1);
      }
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },


    async getTotalOfBilan() {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalTTC = response.data[2].prixTTC
          this.totalTVA = response.data[2].TVA
          this.prixHT = response.data[2].prixHT
        })
    },


    async createOrUpdateOperationHonoraires(operationHonoraire) {
      let success = true
      let prixToSend = operationHonoraire.data.prixTTC
      if (this.operation && this.operation.isHT && operationHonoraire.data.tauxTVA) {
        const taux = parseFloat(operationHonoraire.data.tauxTVA.replace('%', '')) / 100
        prixToSend = operationHonoraire.data.prixHT * (1 + taux)
      }


      let data = new FormData()
      if (operationHonoraire.data.operationLot != null) {
        data.append('operationLotId', operationHonoraire.data.operationLot.id)
      }
      if (operationHonoraire.data.operation != null) {
        data.append('operationId', operationHonoraire.data.operation.id)
        data.append('selectedLotsIds', operationHonoraire.selectedLots)
      }
      data.append('type', operationHonoraire.data.type)
      data.append('prixTTC', prixToSend)
      data.append('contactName', operationHonoraire.data.contactName)
      data.append('tauxTVA', operationHonoraire.data.tauxTVA)

      if (operationHonoraire.data.hasOwnProperty('isPourcentageConstructionMode')) {
        data.append('isPourcentageConstructionMode', Boolean(operationHonoraire.data.isPourcentageConstructionMode))
      }
      if (operationHonoraire.data.hasOwnProperty('pourcentage') && operationHonoraire.data.pourcentage) {
        data.append('pourcentage', operationHonoraire.data.pourcentage)
      }
      if (operationHonoraire.data.date) {
        data.append('date', operationHonoraire.data.date)
      }
      operationHonoraire.data.devis.forEach((devis, indexDevis) => {
        let devisCopy = {...devis};
        delete devisCopy.documents;

        data.append(`devis[${indexDevis}]`, JSON.stringify(devisCopy));
        if (devis && devis.documents && devis.documents.length > 0) {
          devis.documents.forEach((document, indexDocument) => {
            if (document) {
              if (document instanceof File) {
                data.append(`devisDocuments[${indexDevis}][${indexDocument}]`, document);
              } else {
                if (document && document.id) {
                  data.append(`devisDocumentsAlreadyInDb[${indexDevis}][${indexDocument}]`, document.id);
                }
              }
            }
          });
        }
      });

      if (operationHonoraire.data && operationHonoraire.data.hasOwnProperty("factures") && operationHonoraire.data.factures && operationHonoraire.data.factures.length > 0) {
        operationHonoraire.data.factures.forEach((facture, indexFacture) => {
          let factureCopy = {...facture};
          delete factureCopy.documents;

          data.append(`facture[${indexFacture}]`, JSON.stringify(factureCopy));
          if (facture && facture.documents && facture.documents.length > 0) {
            facture.documents.forEach((document, indexDocument) => {
              if (document) {
                if (document instanceof File) {
                  data.append(`factureDocuments[${indexFacture}][${indexDocument}]`, document);
                } else {
                  if (document && document.id) {
                    data.append(`factureDocumentsAlreadyInDb[${indexFacture}][${indexDocument}]`, document.id);
                  }
                }
              }
            });
          }
        });
      }

      let url = 'operationHonoraire'
      if (operationHonoraire.data.id) {
        url = '/operationHonoraire/' + operationHonoraire.data.id
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          operationHonoraire.data = {
            ...operationHonoraire.data,
            id: response.data.id,
            prixTTC: response.data.totalPrixTTC,
            remainingTTC: response.data.remainingTTC,
            prixHT: response.data.totalPrixHT,
            remainingHT: response.data.remainingHT,
          }
          this.$bvToast.toast(this.$i18n.t('OperationHonoraire') + " " + this.$i18n.t('registered.object'), {
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            noCloseButton: true,
            variant: 'success',
            solid: true,
          })
        })
        .catch(error => {
          success = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 3,
                message: error.response.data.message
              }
            })
          }
        })
      return success
    },

    toast(message, variant) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: variant,
        solid: true,
      })
    },

    async deleteOperationHonoraires(operationHonoraire) {
      if (operationHonoraire) {
        await api
          .delete(`/operationHonoraire/${operationHonoraire.id}`)
      }
    },

    async editOperationBilan() {

      let data = new FormData()
      data.append('honorairesDone', true)

      api({
        method: 'POST',
        url: '/operationBilan/' + this.operationBilanId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },
  }
}
</script>

<style scoped>
.custom-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: -1em;
}

.custom-container > * {
  margin-left: 1em;
}

.info-text {
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
}

.intitule{
  padding: 4px 16px;
  margin-right: 80px;
  height: 35px;
}

.mar-r-100{
  margin-right: 100px;
}

.mar-l-40{
  margin-left: 40px;
}

.mar-l-100{
  margin-left: 100px;
}

.mar-r-100{
  margin-right: 100px;
}

.section-type-honoraire:not(:first-child) {
  margin-top: 3em
}

.section-type-honoraire:first-child {
  margin-top: 0.5em
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanEditSteps/OperationBilanHonorairesEdit.vue